<div class="form-group">
    <div class="dropdown">
        <button aria-expanded="false" aria-haspopup="true"
            class="select--button {{isLight ? 'light': ''}} {{isRequire? 'require': ''}}" data-toggle="dropdown"
            id="dropdownMenu2" type="button" role="button">
            <span> {{value || defaultTitle}} </span>
            <span>
                <img src="assets/images/icon/caret-down@2x.png" alt="arrow-dropdown" />
            </span>
        </button>
        <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
            <div class="bs-searchbox" *ngIf="enableSearch">
                <input aria-label="Search" autocomplete="on" class="form-control" role="textbox" type="text" #FundCode
                    (keyup)="searchFund(FundCode.value)">
            </div>
            <ul aria-expanded="false" class="menu--list" role="listbox" style="max-height: 450px; overflow-y: auto;">
                <li class="dropdown-item" style="height: 50px;" *ngFor="let item of selectList2 "
                    data-original-index="1" (click)="onListClick(item)">
                    <a aria-disabled="false" aria-selected="false" class="" data-tokens="null" role="option"
                        ta-tokens="null" tabindex="0">
                        <span class="text">{{item.title}}</span>
                        <span class="glyphicon glyphicon-ok check-mark"></span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>